'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { HUBL_DOCS_FETCH } from 'DesignData/actions/ActionTypes';
/*
 * hublDocs fetching
 */

export default function hublDocs(state = SeamlessImmutable({}), action) {
  switch (action.type) {
    case HUBL_DOCS_FETCH:
      {
        const {
          docs
        } = action;

        if (!docs) {
          return state;
        }

        return state.merge({
          docs
        });
      }

    default:
      return state;
  }
}